// First active wins for older conflicting selections; none active = maximum.
export const CRIT_VARIANT_RULES = [
    ['rolled', '6CFB808D-D8BE-7A0C-E2E2-03F68E26DDA8'],
    ['doubled', '726E0917-9257-23FD-A18C-C07B4C00B8A1'],
    ['maximum', '2087C1FB-57E3-2E51-AC0E-6FF8C15629AA'],
] as const;

export interface CampaignHouseRuleSelection {
    kind: 'campaign_house_rule';
    campaign_house_rule_id: string;
    campaign_house_rule_deleted: 0 | 1;
}

export function isCritVariantRule(id: string): boolean {
    return CRIT_VARIANT_RULES.some(([, ruleId]) => ruleId === id.toUpperCase());
}

/** A toggle changes only itself, plus the competing crit models when enabling one. */
export function campaignHouseRuleSelection(id: string, enabled: boolean): CampaignHouseRuleSelection[] {
    const selected = id.toUpperCase();
    const ids = enabled && isCritVariantRule(selected) ? CRIT_VARIANT_RULES.map(([, ruleId]) => ruleId) : [selected];
    return ids.map(ruleId => ({ kind: 'campaign_house_rule', campaign_house_rule_id: ruleId,
        campaign_house_rule_deleted: enabled && ruleId === selected ? 0 : 1 }));
}
